export const query = `query getCheckoutSettings {
  checkoutSettings {
    delayCaptureEnabled
    taxOnProduct
    termsAndConditions {
      value
      enabled
    }
    privacyPolicy {
      value
      enabled
    }
    digitalItemPolicy {
      value
      enabled
    }
    refundCancellationPolicy {
      value
      enabled
    }
    contactUs {
      value
      enabled
    }
    customPolicy {
      value
      enabled
      title
    }
    checkoutPolicyCheckbox {
      checked
      show
    }
    checkoutSubscriptionCheckbox {
      checked
      show
    }
    checkoutGiftCardCheckbox {
      show
      supported
    }
  }
}`;
//# sourceMappingURL=getCheckoutSettings.graphql.js.map